/*
 *
 * DimensionByDivision constants
 *
 */
export const GET_DIVISIONS_WATCHER =
  "app/DimensionByDivision/GET_DIVISIONS_WATCHER"
export const GET_DIVISIONS_SUCCESS =
  "app/DimensionByDivision/GET_DIVISIONS_SUCCESS"
export const GET_DIVISIONS_FAILED =
  "app/DimensionByDivision/GET_DIVISIONS_FAILED"

export const GET_DIMENSIONS_WATCHER =
  "app/DimensionByDivision/GET_DIMENSIONS_WATCHER"
export const GET_DIMENSIONS_SUCCESS =
  "app/DimensionByDivision/GET_DIMENSIONS_SUCCESS"
export const GET_DIMENSIONS_FAILED =
  "app/DimensionByDivision/GET_DIMENSIONS_FAILED"

export const GET_ONLY_DIMENSIONS_WATCHER =
  "app/DimensionByDivision/GET_ONLY_DIMENSIONS_WATCHER"
export const GET_ONLY_DIMENSIONS_SUCCESS =
  "app/DimensionByDivision/GET_ONLY_DIMENSIONS_SUCCESS"
export const GET_ONLY_DIMENSIONS_FAILED =
  "app/DimensionByDivision/GET_ONLY_DIMENSIONS_FAILED"

export const GET_QUESTIONS_WATCHER =
  "app/DimensionByDivision/GET_QUESTIONS_WATCHER"
export const GET_QUESTIONS_SUCCESS =
  "app/DimensionByDivision/GET_QUESTIONS_SUCCESS"
export const GET_QUESTIONS_FAILED =
  "app/DimensionByDivision/GET_QUESTIONS_FAILED"

export const GRAPHIC_BARS_WATCHER =
  "app/DimensionByDivision/GRAPHIC_BARS_WATCHER"
export const GRAPHIC_BARS_SUCCESS =
  "app/DimensionByDivision/GRAPHIC_BARS_SUCCESS"
export const GRAPHIC_BARS_FAILED = "app/DimensionByDivision/GRAPHIC_BARS_FAILED"

export const GET_HISTORY_BY_DIVISION_WATCHER =
  "app/DimensionByDivision/GET_HISTORY_BY_DIVISION_WATCHER"
export const GET_HISTORY_BY_DIVISION_SUCCESS =
  "app/DimensionByDivision/GET_HISTORY_BY_DIVISION_SUCCESS"
export const GET_HISTORY_BY_DIVISION_FAILED =
  "app/DimensionByDivision/GET_HISTORY_BY_DIVISION_FAILED"

export const GET_HISTORY_WATCHER = "app/DimensionByDivision/GET_HISTORY_WATCHER"
export const GET_HISTORY_SUCCESS = "app/DimensionByDivision/GET_HISTORY_SUCCESS"

export const GET_AMBASSADORS_WATCHER =
  "app/DimensionByDivision/GET_AMBASSADORS_WATCHER"
export const GET_AMBASSADORS_SUCCESS =
  "app/DimensionByDivision/GET_AMBASSADORS_SUCCESS"
export const GET_AMBASSADORS_FAILED =
  "app/DimensionByDivision/GET_AMBASSADORS_FAILED"

export const GET_MEASURE_COLOR_RANGE_WATCHER =
  "app/DimensionByDivision/GET_MEASURE_COLOR_RANGE_WATCHER"
export const GET_MEASURE_COLOR_RANGE_SUCCESS =
  "app/DimensionByDivision/GET_MEASURE_COLOR_RANGE_SUCCESS"
